import { render } from "./EditWeightedScorePage.vue?vue&type=template&id=2a720d74&ts=true"
import script from "./EditWeightedScorePage.vue?vue&type=script&lang=ts"
export * from "./EditWeightedScorePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__